<ngb-toast *ngFor="let toast of toastService.toasts" class="toast-container position-fixed top-0 end-0" [class]="toastService.class(toast)" [autohide]="true" [delay]="toast.delay || 2000" (hidden)="toastService.remove(toast)">
    <ng-template [ngIf]="toast.type == 'error'">
        <i class="fa fa-exclamation-triangle fa-lg"></i>
    </ng-template>

    <ng-template [ngIf]="toast.type == 'success'">
        <i class="fa fa-check-circle fa-lg"></i>
    </ng-template>

    <ng-template [ngIf]="toast.type == 'warning'">
        <i class="fa fa-exclamation-triangle fa-lg"></i>
    </ng-template>

    <ng-template [ngIf]="isTemplate(toast)" [ngIfElse]="text">
        <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
    </ng-template>

    <ng-template #text> {{ toast.textOrTpl }}</ng-template>
</ngb-toast>